import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from 'react-icons/bs';
import { loadModules } from 'esri-loader';

const IWW_NPM_KPI = ({ data, changeValues, filter }) => {

    const { setValues, values, sumTotal, formatNumber, calculoPromedio, calculoPer100km, calculoLocks, calculoperTypeLock } = useKPIs();

    const [formValues, setFormValues] = useState({});
    const [attributes, setAttributes] = useState({});
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)


    useEffect(() => {
        getRegionalPartnerGeo();
    }, [filter.objectid]);

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {

        const datas = {
            infrastructure: {
                locks: calculoLocks(),
                lock_type: {
                    double_lock: calculoperTypeLock('double_lock'),
                    single_lock: calculoperTypeLock('single_lock')
                },
                its: calculoPromedio('its'),
                heavyPreiodicMainReq: {
                    req_heavy_maint: calculoPromedio('req_heavy_maint'),
                    req_rehab: calculoPromedio('req_rehab')
                },
                req_upgrade_inc_cap: calculoPromedio('req_upgrade_inc_cap'),
                climateChangeResil: {
                    ch_flood_inci: calculoPer100km('ch_flood_inci'),
                    ch_closure_adv_weather_cond: calculoPer100km('ch_closure_adv_weather_cond'),
                    ch_embank_fail: calculoPer100km('ch_embank_fail')
                }
            },
            maintenance: {
                maint_cost_total_py: formatNumber(sumTotal('maint_cost_total_py')),
                maint_cost_landslide_py: formatNumber(sumTotal('maint_cost_landslide_py')),
                maint_cost_riverslide_py: formatNumber(sumTotal('maint_cost_riverslide_py'))
            },
            environmentalImpact: {
                co2_ems: calculoPer100km('co2_ems'),
                nox_ems: calculoPer100km('nox_ems'),
                so2_ems: calculoPer100km('so2_ems'),
                nmhc_ems: calculoPer100km('nmhc_ems'),
                ppm: calculoPer100km('ppm')
            }
        }

        changeValues(datas)
    }

    const getRegionalPartnerGeo = async () => {
        console.log("getRegionalPartnerGeo is called");
        try {
            const [Query, query] = await loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/6";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `npm_iww_id=${filter.objectid}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            console.log("Executing query");
            const results = await query.executeQueryJSON(queryUrl, queryObject);
            console.log("Query executed", results);

            if (results.features.length > 0) {
                const attributes = results.features[0].attributes;
                setAttributes(attributes);
                setFormValues(attributes);
                setStatusTabDisabled(false);
            } else {
                console.log("No features found with the given npmRoadId");
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const key = name.split('.').pop();

        // Detecta el tipo original del valor
        const originalValue = formValues[key];
        let newValue = value;

        // Convertir a número si el valor original es un número
        if (!isNaN(originalValue) && originalValue !== null && originalValue !== "") {
            newValue = Number(value);
        }

        setFormValues({
            ...formValues,
            [key]: newValue,
        });
    };


    const generateFormFields = (formValues, typeForm) => {
        const excludedFields = ["objectid", "globalid", "npm_road_id"];

        return Object.keys(formValues)
            .filter(key => !excludedFields.includes(key))
            .map(key => (
                <Col lg={6} key={key}>
                    <TODIS_FORM_FIELD
                        id={`${typeForm}.${key}`}
                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                        name={`${typeForm}.${key}`}
                        disabled={true}
                        holder={formValues[key]}
                        onChange={handleChange}
                    />
                </Col>
            ));
    };

    return (
        <Tabs defaultActiveKey="Infrastructure" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="Infrastructure" title="Infrastructure" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.locks" label="Locks (no./100 km)" name="infrastructure.locks" disabled={true} />
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Locks type</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.lock_type.double_lock" label="Double locks (%)" name="infrastructure.lock_type.double_lock" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.lock_type.single_lock" label="Single locks(%)" name="infrastructure.lock_type.single_lock" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.its" label="Percentage of IWW network covered by ITS" name="infrastructure.its" disabled={true} />
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Heavy/Periodic Maintenance Requirements</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_heavy_maint" label="Percentage of network km requiring heavy maintenance" name="infrastructure.heavyPreiodicMainReq.req_heavy_maint" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.heavyPreiodicMainReq.req_rehab" label="Percentage of network km requiring rehabilitation" name="infrastructure.heavyPreiodicMainReq.req_rehab" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="infrastructure.req_upgrade_inc_cap" label="Percentage of network km requiring upgrade to increase capacity" name="infrastructure.req_upgrade_inc_cap" disabled={true} />
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Climate Change Resilience</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_flood_inci" label="Number of flooding incidents per 100km" name="infrastructure.climateChangeResil.ch_flood_inci" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" label="Number of closures due to adverse weather conditions per 100km" name="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_embank_fail" label="Number of embankment failures per 100km" name="infrastructure.climateChangeResil.ch_embank_fail" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Maintenance" title="Maintenance" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_total_py" label="Maintenance cost – Total (Euro/km)" name="maintenance.maint_cost_total_py" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_landslide_py" label="Maintenance cost - Landside Infrastructure (Euro/km)" name="maintenance.maint_cost_landslide_py" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_riverslide_py" label="Maintenance cost - Riverside Infrastructure (Euro/km)" name="maintenance.maint_cost_riverslide_py" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Environmental" title="Environmental Impact" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.co2_ems" label="CO2 emissions (tons/100 km)" name="environmentalImpact.co2_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.nox_ems" label="NOx emissions (tons/100 km)" name="environmentalImpact.nox_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.so2_ems" label="SO2 emission evolution (tons/100 km)" name="environmentalImpact.so2_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.nmhc_ems" label="Non-methane hydrocarbons (tons/100 km)" name="environmentalImpact.nmhc_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.ppm" label="Particulate matter (ppm) (tons/100 km)" name="environmentalImpact.ppm" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :

                <Tab eventKey="Others" title="Others" className={style.tabHeight}>
                    <Container>
                        <Row>
                            {generateFormFields(attributes)}
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default IWW_NPM_KPI;